/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLegend = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 13a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm16 5v2H12v-2zM6 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12-1v2h-6v-2zM6 3l1.237 2.505L10 5.906 8 7.855l.47 2.754L6 9.309l-2.471 1.3.47-2.754-2-1.949 2.765-.401zm16 5v2H12V8zm-4-4v2h-6V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLegend as Legend };
